import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import DlGroupList from "./pages/dl_group/DlGroupList";
import AdminLayout from "./layout/AdminLayout";
import { useAuthCurrent } from "hooks/auth/auth_current";
import { AddNavigationProvider } from "common/modal/AddNavigation";
import Users from "./pages/user/Users";
import UserEdit from "./pages/user/UserEdit";
import UserNew from "./pages/user/UserNew";
import DlGroupNew from "./pages/dl_group/DlGroupNew";
import DlGroupEdit from "./pages/dl_group/DlGroupEdit";
import DlUnitNew from "./pages/dl_unit/DlUnitNew";
import DlUnitEdit from "./pages/dl_unit/DlUnitEdit";
import PhotoSeriesEdit from "./pages/photo_series/PhotoSeriesEdit";
import PhotoSeriesList from "./pages/photo_series/PhotoSeriesList";
import UnitEditList from "./pages/dl_unit/UnitEditList";
import UnitScanEdit from "./pages/dl_unit/UnitScanEdit";
import UnitPdfEdit from "./pages/dl_unit/UnitPdfEdit";
import PhotoSeriesNew from "./pages/photo_series/PhotoSeriesNew";
import PhotoSeriesEditPhoto from "./pages/photo_series/PhotoSeriesEditPhoto";

export default function AdmApp() {
  const authCurrent = useAuthCurrent();
  const navigate = useNavigate();

  const isLoading = authCurrent === undefined || authCurrent === null;

  // useEffect(() => {
  //   // console.log("authCurrent", authCurrent);
  //   if (!authCurrent || !authCurrent.un || authCurrent.un === "") {
  //     navigate("/l-in");
  //   }
  // }, [authCurrent]);

  useEffect(() => {
    // Only redirect if auth is loaded and user is not authenticated
    if (
      !isLoading &&
      (!authCurrent || !authCurrent.un || authCurrent.un === "")
    ) {
      navigate("/l-in");
    }
  }, [authCurrent, isLoading, navigate]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <AddNavigationProvider>
      <Routes>
        <Route element={<AdminLayout />}>
          <Route path="/" element={<UnitEditList />} />
          {/* <Route path="l-out" element={<ToLogout />} /> */}
          <Route path="dl-group-li" element={<DlGroupList />} />
          <Route path="dl-group-new" element={<DlGroupNew />} />
          <Route path="dl-group-edit/:itemId" element={<DlGroupEdit />} />
          <Route path="photo-ser-li" element={<PhotoSeriesList />} />
          <Route path="photo-ser-edit/:itemId?" element={<PhotoSeriesEdit />} />
          <Route
            path="photo-ser-edit/:itemId/photo"
            element={<PhotoSeriesEditPhoto />}
          />
          <Route path="photo-ser-new" element={<PhotoSeriesNew />} />
          <Route path="user-li" element={<Users />} />
          <Route path="user-edit/:itemId?" element={<UserEdit />} />
          <Route path="user-new" element={<UserNew />} />
          <Route path="dl-unit-li" element={<UnitEditList />} />
          <Route path="dl-unit-new" element={<DlUnitNew />} />
          <Route path="dl-unit-edit/:itemId" element={<DlUnitEdit />} />
          <Route path="dl-unit-edit/:itemId/scan" element={<UnitScanEdit />} />
          <Route path="dl-unit-edit/:itemId/pdf" element={<UnitPdfEdit />} />
        </Route>
      </Routes>
    </AddNavigationProvider>
  );
}
